module.exports = __webpack_public_path__ + "static/media/calendar.692d308b.svg";